import { codeSplit } from 'bernie-core';

export const roomsAndRatesLoadable = {
  webpackChunkName: 'infosite-RoomsAndRates',
  codeSplit: codeSplit(() => import(/* webpackChunkName: "infosite-RoomsAndRates" */ './index') as any),
};

export const roomRatePlansWrapperLoadable = {
  webpackChunkName: 'infosite-RoomRatePlans',
  codeSplit: codeSplit(() => import(/* webpackChunkName: "infosite-RoomRatePlans" */ './room-rate-plans-wrapper') as any),
};
